import university from '@/libs/acl/roles/university'

export default {
  SET_DC_TYPES(state, data) {
    state.dcTypes = data
  },
  SET_ROLES(state, data) {
    state.roles = data
  },
  SET_SCIENTIFIC_DEGREES(state, data) {
    state.scientificDegrees = data
  },
  SET_SCIENTIFIC_TITLES(state, data) {
    state.scientificTitles = data
  },
  SET_ORG_TYPES(state, data) {
    state.orgTypes = data
  },
  SET_PERIOD_TYPES(state, data) {
    state.periodTypes = data
  },
  SET_LETTER_STATUSES(state, data) {
    state.letterStatuses = data
  },
  SET_APPLY_DOCUMENT_STATUSES(state, data) {
    state.applyDocumentStatuses = data
  },
  SET_LETTER_TYPES(state, data) {
    state.letterTypes = data
  },
  EDU_LANG_TYPES(state, data) {
    state.eduLangTypes = data
  },
  SET_SCIENTIFIC_WORK_TYPES(state, data) {
    state.scientificWorkTypes = data
  },
  SET_ACTIVE_QUARTER(state, data) {
    state.activeQuarter = data
  },
  SET_QUOTE_ORG_TYPES(state, data) {
    state.quoteOrgTypes = data
  },
  SET_TOTAL_QUOTE_TYPES(state, data) {
    state.totalQuoteTypes = data
  },
  SET_QUOTES(state, data) {
    state.quotes = data
  },
  SET_DIRECTION_LIST(state, data) {
    state.directionList = data
  },
  SET_CATEGORY_SUBJECT_LIST(state, data) {
    state.categorySubjectList = data
  },
  SET_UNIVERSITY_LIST(state, data) {
    state.universityList = data
  },
  SET_PERIOD_LIST(state, data) {
    state.periodList = data
  },
  SET_ADMISSION_YEAR_PERIOD_LIST(state, data) {
    state.admissionYearPeriodList = data
  },
  SET_ORGANIZATION_LIST(state, data) {
    state.organizationList = data
  },
  SET_RESEARCH_ADVISORS(state, data) {
    state.researchAdvisors = data
  },
  SET_REGION_LIST(state, data) {
    state.regions = data
  },
  SET_SCIENTIFIC_TOPIC_DIRECTIONS(state, data) {
    state.scientificTopicDirections = data
  },
  SET_CERTIFICATE_LIST(state, data) {
    state.certificateList = data
  },
  SET_CERTIFICATE_TYPES(state, data) {
    state.certificateTypes = data
  },
}
